import PropTypes from 'prop-types'
import { useState } from 'react'
import { ListGroup, ListGroupItem, CustomInput, Collapse } from 'reactstrap'
import './_product-filter.scss'

const propTypes = {
  formik    : PropTypes.object,
  fieldName : PropTypes.string,
  colours   : PropTypes.arrayOf(PropTypes.object)
}

const defaultProps = {
  formik    : {},
  fieldName : '',
  colours   : [ {} ]
}

/**
 * @param {string} name - name of the field in formik
 * @param {[string]} colours - options for colours
 */
const ProductColourFilterField = ({
  formik,
  fieldName,
  colours
}) => {

  const [ collapse, setCollapse ] = useState(true)

  const handleChange = (event, colour) => {
    const { checked } = event.target
    const colourId    = colour.id
    if (checked) {
      // manually push to formik values
      const newSelectedColourIds = [ ...formik.values[ fieldName ], colourId ]
      formik.setFieldValue(fieldName, newSelectedColourIds)
    } else {
      const newSelectedColourIds = formik.values[fieldName].filter((formikColourId) => formikColourId !== colourId)
      formik.setFieldValue(fieldName, newSelectedColourIds)
    }
  }
  return (
    <>
      <div className='filter-title font-weight-bold pb-2'
        onClick={ () => setCollapse(!collapse) }
      >
        { 'COLOURS' }
        <i className={ `float-right fas fa-chevron-${ collapse ? 'up' : 'down' }` } />
      </div>

      <Collapse isOpen={ collapse }>
        <ListGroup flush>
          {
            colours.map((colour) => (
              <ListGroupItem
                key={ `colours-filter-options-${colour.id}` }
                name='colour_ids'
              >
                {
                  colour.hex_code != null ?
                    <div
                      className='filter-color__img'
                      style={{ backgroundColor: `#${colour.hex_code}` }}
                    />
                    :
                    <img
                      className='filter-color__img'
                      src={ `https://www.tinkerlust.com/${colour.image_url}` }
                    />

                }
                <small>{ colour.label }</small>
                <CustomInput
                  id={ colour.label }
                  name={ colour.label }
                  type='checkbox'
                  checked={ formik.values[fieldName].includes(colour.id) }
                  onChange={ (event) => handleChange(event, colour) }
                  className='float-left'
                />
              </ListGroupItem>
            ))
          }
        </ListGroup>
      </Collapse>
    </>
  )
}

ProductColourFilterField.propTypes    = propTypes
ProductColourFilterField.defaultProps = defaultProps

export default ProductColourFilterField
